import config from "@/config";

// A config variant without `integrations` keeps every integration on.
export const integrationEnabled = (name) => config.integrations?.[name] !== false;

// Routes that need Flexwell or Zoho name them in `meta.requires`. The router
// guard and the sidebar both ask this, so a hidden menu item is also an
// unreachable page.
export const routeAvailable = (route) =>
	route.matched.every((record) => (record.meta.requires || []).every(integrationEnabled));
